module.exports = __webpack_public_path__ + "img/Dutch.70d652bf.svg";